
import { Options, Vue } from "vue-class-component";

@Options({
  name: "MapyQr",
})
export default class MapyQr extends Vue {}
